export default __webpack_public_path__ + "static/hero-video-045291e0949754c5ac5d7a09bb4a499e.mp4";